export default "__VITE_ASSET__D9j3zpO9__"